import { createSlice } from "@reduxjs/toolkit";
import type { CatalogBin } from "../../../models/CatalogBin";

const CatalogBinInitialState: {
  bins: CatalogBin[] | null;
} = {
  bins: null,
};

export const CatalogBinReducer = createSlice({
  name: "__",
  initialState: CatalogBinInitialState,
  reducers: {
    setBins(state, { payload }) {
      state.bins = payload;
    },
  },
});
